module.exports = __webpack_public_path__ + "img/img_06.d8f60ee5.png";